import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { contactInfo } from '../data/mock';

const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show button after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip for 5 seconds
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 5000);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello! I'm interested in RK ROTOARC welding products. Can you help me?");
    const phone = `91${contactInfo.whatsapp}`;
    
    // Try to open WhatsApp app first, fallback to web
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      // On mobile, use intent or direct app link
      window.location.href = `whatsapp://send?phone=${phone}&text=${message}`;
    } else {
      // On desktop, use web WhatsApp
      window.open(`https://web.whatsapp.com/send?phone=${phone}&text=${message}`, '_blank');
    }
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
        {/* Tooltip */}
        {showTooltip && (
          <div className="bg-white border border-zinc-200 rounded-lg shadow-xl px-4 py-3 mr-2 max-w-xs animate-fade-in">
            <div className="flex items-start justify-between gap-2 mb-2">
              <p className="text-sm font-semibold text-black">Need Help?</p>
              <button 
                onClick={() => setShowTooltip(false)}
                className="text-zinc-400 hover:text-black"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <p className="text-xs text-zinc-600">
              Chat with us on WhatsApp for quick assistance!
            </p>
          </div>
        )}

        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsAppClick}
          className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 animate-fade-in"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle className="w-6 h-6" />
          
          {/* Pulse Animation */}
          <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></span>
          
          {/* Hover Tooltip */}
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-green-500 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            Chat on WhatsApp
          </span>
        </button>
      </div>
    </>
  );
};

export default FloatingWhatsApp;
